export enum Network {
  ARBITRUM = 'arbitrum',
  AVALANCHE = 'avalanche',
  BASE = 'base',
  BASE_SEPOLIA = 'base sepolia',
  BERACHAIN = 'berachain',
  BERACHAIN_BARTIO = 'berachain bartio',
  BITFINITY = 'bitfinity',
  BITLAYER = 'bitlayer',
  BLAST_SEPOLIA = 'blast sepolia',
  BNB = 'bnb',
  CELO = 'celo',
  CORN = 'corn',
  ETHEREUM = 'ethereum',
  FANTOM = 'fantom',
  HEMI = 'hemi-testnet',
  HOLESKY = 'holesky',
  LINEA = 'linea',
  LOCALHOST = 'localhost',
  LUKSO = 'lukso',
  MANTLE = 'mantle',
  MODE = 'mode',
  OPTIMISM = 'optimism',
  POLYGON = 'polygon',
  SEPOLIA = 'sepolia',
  ZK_SYNC = 'zkSync',
  ABSTRACT = 'abstract',
  SONIC = 'sonic',
  SEI = 'sei',
  Subtensor = 'subtensor',
  MonadTestnet = 'monad testnet',
  Monad = 'monad',
  Katana = 'katana',
  HyperEVM = 'hyperEVM',
  AvalancheFuji = 'avalanche-fuji',
  TAC = 'TAC',
  PLASMA = 'plasma',
  INK = 'ink',
  INK_SEPOLIA = 'ink-sepolia',
  RAYLS_TESTNET = 'rayls testnet',
  STABLE = 'stable',
}

export interface NetworkData {
  scannerBaseUrl: string;
  testnet: boolean;
  apiKey?: string;
  chainId: number;
  name: Network;
  canBeUsedForOnChain?: boolean;
  canBeUsedForTokenHolders?: boolean;
  canBeUsedForSubgraphBalance?: boolean;
  canBeUsedForNadoTrade?: boolean;
  canBeUsedForMorpho?: boolean;
  canBeUsedForReferredVolume?: boolean;
  canBeUsedForPendle?: boolean;
  canBeUsedForEuler?: boolean;
}

export const NETWORKS: NetworkData[] = [
  ...(process.env.NEXT_PUBLIC_HARDHAT_NETWORK
    ? [
        {
          scannerBaseUrl: 'http://localhost:8545',
          testnet: true,
          chainId: 31337,
          name: Network.LOCALHOST,
          canBeUsedForOnChain: true,
          canBeUsedForTokenHolders: true,
          canBeUsedForSubgraphBalance: false,
        },
      ]
    : []),
  {
    apiKey: 'PK3Q3TR2D1C2FDVYU6D9ZIEE318Z6VGSCB',
    scannerBaseUrl: 'https://etherscan.io',
    testnet: false,
    chainId: 1,
    name: Network.ETHEREUM,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForSubgraphBalance: true,
    canBeUsedForMorpho: true,
    canBeUsedForReferredVolume: true,
    canBeUsedForPendle: true,
    canBeUsedForEuler: true,
  },
  {
    name: Network.BITLAYER,
    scannerBaseUrl: 'https://bitlayer.io',
    testnet: false,
    chainId: 200901,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForSubgraphBalance: false,
  },
  {
    apiKey: 'BHH4KACVG89S34P5EEDD3WPIXMQEC1UP8J',
    scannerBaseUrl: 'https://polygonscan.com',
    testnet: false,
    chainId: 137,
    name: Network.POLYGON,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
  },
  {
    apiKey: '2I8DJ748YMIZ9TAKCUB37UU65FXTES5VCJ',
    scannerBaseUrl: 'https://arbiscan.io',
    testnet: false,
    chainId: 42161,
    name: Network.ARBITRUM,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForSubgraphBalance: false,
    canBeUsedForReferredVolume: true,
  },
  {
    apiKey: '68TQP88VUMA1ESHUSFGN1F1R34ZF1FAQY5',
    scannerBaseUrl: 'https://bscscan.com',
    testnet: false,
    chainId: 56,
    name: Network.BNB,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForSubgraphBalance: true,
    canBeUsedForPendle: true,
  },
  {
    apiKey: 'TUTSIVQXAS6YNRTFC3HPZK2R6545RKYP51',
    scannerBaseUrl: 'https://optimistic.etherscan.io',
    testnet: false,
    chainId: 10,
    name: Network.OPTIMISM,
    canBeUsedForOnChain: true,
    canBeUsedForReferredVolume: true,
  },
  {
    scannerBaseUrl: 'https://basescan.org',
    testnet: false,
    chainId: 8453,
    name: Network.BASE,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForMorpho: true,
    canBeUsedForReferredVolume: true,
    canBeUsedForEuler: true,
    canBeUsedForPendle: true,
  },
  {
    scannerBaseUrl: 'https://lineascan.build',
    testnet: false,
    chainId: 59144,
    name: Network.LINEA,
    canBeUsedForOnChain: true,
  },
  {
    scannerBaseUrl: 'https://sepolia.etherscan.io',
    testnet: true,
    chainId: 11155111,
    name: Network.SEPOLIA,
    canBeUsedForOnChain: true,
  },
  {
    scannerBaseUrl: 'https://snowtrace.io',
    testnet: false,
    chainId: 43114,
    name: Network.AVALANCHE,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
  },
  {
    scannerBaseUrl: 'https://explorer.mantle.xyz',
    testnet: false,
    chainId: 5000,
    name: Network.MANTLE,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForSubgraphBalance: false,
  },
  {
    scannerBaseUrl: 'https://explorer.mode.network',
    testnet: false,
    chainId: 34443,
    name: Network.MODE,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
  },
  {
    scannerBaseUrl: 'https://explorer.mainnet.bitfinity.network',
    testnet: false,
    chainId: 355110,
    name: Network.BITFINITY,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForSubgraphBalance: false,
  },
  {
    scannerBaseUrl: 'https://celoscan.io',
    testnet: false,
    chainId: 42220,
    name: Network.CELO,
    canBeUsedForOnChain: true,
    canBeUsedForSubgraphBalance: false,
  },
  {
    scannerBaseUrl: 'https://testnet.blastscan.io',
    testnet: true,
    chainId: 168587773,
    name: Network.BLAST_SEPOLIA,
    canBeUsedForOnChain: false,
  },
  {
    scannerBaseUrl: 'https://sepolia.basescan.org',
    testnet: true,
    chainId: 84532,
    name: Network.BASE_SEPOLIA,
    canBeUsedForOnChain: true,
  },
  {
    scannerBaseUrl: 'https://testnet.explorer.hemi.xyz',
    testnet: true,
    chainId: 743111,
    name: Network.HEMI,
    canBeUsedForOnChain: false,
  },
  {
    scannerBaseUrl: 'https://explorer.zksync.io',
    testnet: false,
    chainId: 324,
    name: Network.ZK_SYNC,
    canBeUsedForOnChain: true,
  },
  {
    scannerBaseUrl: 'https://berascan.com',
    testnet: false,
    chainId: 80094,
    name: Network.BERACHAIN,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
  },
  {
    scannerBaseUrl: 'https://bartio.beratrail.io',
    testnet: true,
    chainId: 80084,
    name: Network.BERACHAIN_BARTIO,
    canBeUsedForOnChain: false,
    canBeUsedForTokenHolders: false,
  },
  {
    apikey: 'TUTSIVQXAS6YNRTFC3HPZK2R6545RKYP51',
    scannerBaseUrl: 'https://api-holesky.etherscan.io',
    testnet: true,
    chainId: 17000,
    name: Network.HOLESKY,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: false,
    canBeUsedForSubgraphBalance: false,
  },
  {
    apiKey: 'TUTSIVQXAS6YNRTFC3HPZK2R6545RKYP51',
    scannerBaseUrl: 'https://cornscan.io',
    testnet: false,
    chainId: 21000000,
    name: Network.CORN,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForSubgraphBalance: false,
  },
  {
    scannerBaseUrl: 'https://abscan.org',
    testnet: false,
    chainId: 2741,
    name: Network.ABSTRACT,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: false,
    canBeUsedForSubgraphBalance: false,
  },
  {
    apiKey: 'TUTSIVQXAS6YNRTFC3HPZK2R6545RKYP51',
    scannerBaseUrl: 'https://sonicscan.org',
    testnet: false,
    chainId: 146,
    name: Network.SONIC,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: false,
    canBeUsedForSubgraphBalance: false,
  },
  {
    apiKey: 'TUTSIVQXAS6YNRTFC3HPZK2R6545RKYP51',
    scannerBaseUrl: 'https://www.seiscan.app/pacific-1',
    testnet: false,
    chainId: 1329,
    name: Network.SEI,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: false,
    canBeUsedForSubgraphBalance: false,
  },
  {
    scannerBaseUrl: 'https://evm-testscan.dev.opentensor.ai',
    testnet: true,
    chainId: 964,
    name: Network.Subtensor,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForSubgraphBalance: false,
  },
  {
    scannerBaseUrl: 'https://monad-testnet.socialscan.io',
    testnet: true,
    chainId: 10143,
    name: Network.MonadTestnet,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForSubgraphBalance: false,
  },
  {
    scannerBaseUrl: 'https://monadscan.com',
    testnet: false,
    chainId: 143,
    name: Network.Monad,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForSubgraphBalance: false,
  },
  {
    scannerBaseUrl: 'https://explorer.execution.mainnet.lukso.network',
    testnet: false,
    chainId: 42,
    name: Network.LUKSO,
    canBeUsedForOnChain: true,
  },
  {
    scannerBaseUrl: 'https://katanascan.com',
    testnet: false,
    chainId: 747474,
    name: Network.Katana,
    canBeUsedForTokenHolders: true,
  },
  {
    scannerBaseUrl: 'https://hyperevmscan.io',
    testnet: false,
    chainId: 999,
    name: Network.HyperEVM,
    canBeUsedForTokenHolders: true,
    canBeUsedForOnChain: true,
    canBeUsedForSubgraphBalance: true,
    canBeUsedForPendle: true,
  },
  {
    scannerBaseUrl: 'https://testnet.avascan.info',
    testnet: true,
    chainId: 43113,
    name: Network.AvalancheFuji,
    canBeUsedForTokenHolders: true,
  },
  {
    scannerBaseUrl: 'https://explorer.tac.build',
    testnet: false,
    chainId: 239,
    name: Network.TAC,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
  },
  {
    scannerBaseUrl: 'https://plasmascan.to',
    testnet: false,
    chainId: 9745,
    name: Network.PLASMA,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
  },
  {
    scannerBaseUrl: 'https://explorer.inkonchain.com',
    testnet: false,
    chainId: 57073,
    name: Network.INK,
    canBeUsedForOnChain: true,
    canBeUsedForTokenHolders: true,
    canBeUsedForSubgraphBalance: true,
    canBeUsedForMorpho: true,
    canBeUsedForNadoTrade: true,
  },
  {
    scannerBaseUrl: 'https://explorer-sepolia.inkonchain.com',
    testnet: true,
    chainId: 763373,
    name: Network.INK_SEPOLIA,
    canBeUsedForOnChain: false,
    canBeUsedForNadoTrade: true,
  },
  {
    scannerBaseUrl: 'https://devnet-explorer.rayls.com/',
    testnet: true,
    chainId: 123123,
    name: Network.RAYLS_TESTNET,
    canBeUsedForOnChain: true,
    canBeUsedForNadoTrade: false,
  },
  {
    scannerBaseUrl: 'https://stablescan.xyz',
    testnet: false,
    chainId: 988,
    name: Network.STABLE,
    canBeUsedForTokenHolders: true,
  },
].sort((a, b) => {
  if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
  else if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
  return 0;
});
